import { Component, h, State, Prop, Element } from '@stencil/core';


@Component({
    tag: 'app-search',
    styleUrl: 'app-search.scss'
})
export class AppSearch {
    @Element() root: HTMLElement;
    @State() searchToggleOpen: boolean = false; // Applies to toggle feature
    @Prop() placeholder: string;
    @Prop() label: string;
    @Prop() resultsUrl: string = '/search';

    public searchValue: string;


    componentDidLoad() {
        const searchTermQs = this.getQueryStringValue('searchQuery');
        const searchInput: HTMLInputElement = this.root.querySelector('input.form-control');
        const header: HTMLElement = document.querySelector('header.site-header');

        if (searchTermQs && searchTermQs != '') {
            searchInput.value = searchTermQs;
        }

        this.toggleMobileSearch();
        this.placeMobileSearch();
        window.addEventListener('resize', () => {
            this.placeMobileSearch();
        })

        const mediaQuery = window.matchMedia('(max-width: 1199.98px)');
        const searchOverlay: HTMLElement = document.querySelector('.search-body-overlay');
        mediaQuery.addEventListener('change', (event) => {
            const searchToggle: HTMLButtonElement = this.root.querySelector('button.btn.search-toggle');
            if (event.matches) {
                // Screen width is smaller than 1199.98
                //close search if it is open
                
                searchOverlay.style.top = `${header.offsetHeight}px`

                searchToggle.style.display = 'none';
                if (this.searchToggleOpen) {
                    this.toggleSearch(true);
                }
            } else {
                searchOverlay.style.top = '0';
                searchToggle.style.display = 'block';
                if (this.searchToggleOpen) {
                    this.closeMobileSearch()
                }
            }
        });
    }

    placeMobileSearch() {
        if (window.innerWidth < 1199.98) {
            const searchOverlay: HTMLElement = document.querySelector('.search-body-overlay');
            const header: HTMLElement = document.querySelector('header.site-header');
            const utils: HTMLElement = document.querySelector('.util-nav-list');
            utils.style.top = header.offsetHeight + 'px';
            searchOverlay.style.top = `${header.offsetHeight}px`
        }
    }


    toggleMobileSearch() {
        const toggle: HTMLElement = document.querySelector('.mobile-search-toggle');

        const NavToggle: HTMLElement = document.querySelector('.mobile-nav-toggle');
        const nav: HTMLElement = document.querySelector('.utility-main-nav-wrapper');
        if (!toggle) {
            return;
        }

        toggle.onclick = (e) => {
            const header: HTMLElement = document.querySelector('header.site-header');
            const searchOverlay: HTMLElement = document.querySelector('.search-body-overlay');
            searchOverlay.style.top = `${header.offsetHeight}px`

            e.preventDefault();
            //close naviagation first
            nav.classList.remove('open');
            NavToggle.classList.remove('open');
            document.querySelector('body').classList.remove('menu-entered');

            const appSearch = this.root.querySelector('.search-overlay');
            this.searchToggleOpen = !appSearch.classList.contains('show');
            appSearch.classList.toggle('show')

            toggle.classList.toggle('open');
            document.querySelector('body').classList.toggle('search-open');

            const utils: HTMLElement = document.querySelector('.util-nav-list');
            utils.style.top = header.offsetHeight + 'px';
        };
    }

    searchSubmit(e) {
        e.preventDefault();
        var term = this.searchValue;
        console.log(encodeURIComponent(term))

        if (this.searchValue && this.searchValue.trim() !== null && this.searchValue.trim() !== undefined) {
            var qs = `?searchText=` + encodeURIComponent(this.searchValue.trim()) + '&type=All';
            window.location.href = this.resultsUrl + qs;
        }
    }

    toggleSearch(isClose: boolean) { //Close search if isClose is true otherwise toggle
        const searchOverlay: HTMLElement = document.querySelector('.search-body-overlay');
        searchOverlay.style.top = '0 !important';
        const searchToggle: HTMLButtonElement = this.root.querySelector('button.btn.search-toggle');
        const docBody = document.querySelector('body');
        this.searchToggleOpen = isClose ? false : !this.searchToggleOpen;
        this.root.querySelector('.search-toggle svg').setAttribute('icon', 'search');
        if (isClose) {
            docBody.classList.remove('search-open');
        } else {
            docBody.classList.toggle('search-open');
        }
        if (window.innerWidth > 1198.99) {
            searchToggle.style.display = isClose ? 'block' : 'none';
        }
    }

    closeMobileSearch() {
        this.searchToggleOpen = false;
        const toggle: HTMLElement = document.querySelector('.mobile-search-toggle');
        toggle.classList.remove('open');
        document.querySelector('body').classList.remove('search-open');
    }

    getQueryStringValue(key) {
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    }

    onCloseSearchWithKeyboard(event: KeyboardEvent) {
        if (!event.shiftKey && event.key.toLowerCase() === 'tab') {
            event.preventDefault();
            this.toggleSearch(true);
        }
    }

    onInputSearchWithKeyboard(event: KeyboardEvent) {
        if (event.shiftKey && event.key.toLowerCase() === 'tab') {
            event.preventDefault();
            this.toggleSearch(true);
        }
    }

    render() {
        return (
            <form
                class='app-site-search has-overlay'
                onSubmit={(e) => { this.searchSubmit(e) }}>
                <button
                    type="button"
                    class="btn btn-link search-toggle"
                    id={`site-search-icon-toggle-site-search`}
                    aria-label="Toggle Search"
                    onClick={() => { this.toggleSearch(false) }}>
                    <svg><use href="/themes/custom/qsci/frontend/www/assets/icon/sheets/icons.svg#search"></use></svg>
                </button>
                <label htmlFor='site-search' class="form-label visually-hidden">{this.label}</label>
                <div class={`search-overlay${this.searchToggleOpen ? ' show' : ''}`}>
                    <div class="input-container">
                        <input
                            type="text"
                            class="form-control"
                            required={true}
                            id='site-search'
                            placeholder={this.placeholder}
                            onKeyUp={(e: KeyboardEvent) => this.searchValue = (e.target as HTMLInputElement).value}
                            onKeyDown={(e) => this.onInputSearchWithKeyboard(e)} />
                        <button type="submit" class="input-group-text svg-icon" id={`site-search-icon-site-search`} aria-label="Submit Search">
                            <svg><use href="/themes/custom/qsci/frontend/www/assets/icon/sheets/icons.svg#search"></use></svg>
                        </button>
                    </div>
                    <button
                        type="button"
                        class="btn btn-link"
                        id={`site-search-close-site-search`}
                        aria-label="Close Search"
                        onClick={() => { this.toggleSearch(true) }}
                        onKeyDown={(e) => this.onCloseSearchWithKeyboard(e)}>
                        <svg><use href="/themes/custom/qsci/frontend/www/assets/icon/sheets/icons.svg#close-icon"></use></svg>
                    </button>
                </div>

            </form>
        );
    }
}
